import type { AppEnvironment, EnvironmentFeatures } from './environment.types';

const features: EnvironmentFeatures = {
  reservation: true,
  adminPanel: false,
  analytics: false,
  googleReviews: true,
};

export const environment: AppEnvironment = {
  production: false,
  apiUrl: '',
  /** Must match `tenants.domain` in the DB (see seed). Empty in prod. */
  tenantForwardedHost: 'etterem.pacalkereso.hu',
  /** Branding — applied as CSS variables; tune per tenant deployment. */
  branding: {
    primaryColor: '#5a9e5f',
    secondaryColor: '#111827',
  },
  /** Feature toggles for the SPA (backend still enforces admin APIs). */
  features,
};
